// import { Link } from "react-router-dom";
// import Gdg1 from "../assets/gdg2021.jpg"
// import Gdg2 from "../assets/gdg2021f.jpg"
// import Gdg3 from "../assets/inhagdg2022.jpg"
// import GdgPlov from "../assets/plovgdg.jpg"

import { Link } from "react-router-dom";

function Volunteer() {
    return (
        <div className="volunteer container__blog general-margin_top">
            <h2 className="text-center mb-5">Volunteering / Adventures</h2>
            <p className="blog-text mb-4">
                Bu yerda siz mening har xil meetuplarda qatnashganimu, volunteerliklar qilganligimni ko'rishingiz mumkin bo'ladi.Networkingni oshirish uchun turli xil geeklar (dasturchilar) meetuplarida qatnashib turish juda ham foydali.Biz bunday tadbirlarda qatnashish orqali yangi-yangi tanishlar orttirish imkoniga ega bo'lamiz,albatta bunday tanishlar ish topishda referrallarda (tanish-bilishchilik😀) asqatadi.
            </p>

            <ul>
                <li className="gdgevents-item">
                    <Link to={"/gdgevents"} className='gdg-link'>GDG events</Link>
                </li>
            </ul>
        </div>
    );
}

export default Volunteer;
